<template>
  <section v-if="certificates?.length" class="certificates pe-section">
    <h3>
      Certificates
      <SectionActions
        v-show="isPowerEdit"
        class="actions"
        section="certificates"
      />
    </h3>
    <section class="list">
      <template v-for="(cert, index) in certificates" :key="cert.name">
        <section v-if="cert.name || cert.name" class="certificate">
          <ItemActions
            v-show="isPowerEdit"
            class="itemActions"
            :index="index"
            section="certificates"
            :uuid="cert.uuid"
            :actions="['edit', 'delete']"
          />
          <div class="details">
            <a class="url" :href="getNewTabUrl(cert.url)" target="_blank">
              <div
                @click.prevent
                v-editable="isPowerEdit"
                :data-target-path="`resume.certificates.${index}.name`"
                class="title"
                v-text="cert.name"
              ></div>
            </a>
            <div v-if="cert.date">
              <DateDisplay
                class="date"
                :date="cert.date"
                :updatePath="`resume.certificates.${index}.date`"
                :isEditable="isPowerEdit"
              />
            </div>
          </div>
          <div v-if="cert.issuer" class="issuer">
            <div
              v-editable="isPowerEdit"
              :data-target-path="`resume.certificates.${index}.issuer`"
              v-text="cert.issuer"
            ></div>
          </div>
        </section>
      </template>
    </section>
  </section>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue'
import { Resume } from '@/types/resume/v1'
import DateDisplay from './support/DateDisplay.vue'
import { useStructuredResumeStore } from '@/store/pinia/structuredResume'
import SectionActions from './SectionActions.vue'
import ItemActions from './ItemActions.vue'
import { getNewTabUrl } from '@/lib/urls'

export default defineComponent({
  name: 'Certificates',
  components: { DateDisplay, SectionActions, ItemActions },
  props: {
    certificates: {
      type: Object as PropType<Resume.Certificate[]>,
      required: false,
    },
  },
  setup() {
    const store = useStructuredResumeStore()

    return { isPowerEdit: store.isPowerEdit, getNewTabUrl }
  },
})
</script>

<style lang="postcss" scoped>
.certificates {
  @apply text-base-em leading-[inherit] pt-6-em;
  h3 {
    @apply leading-none text-xl-em flex items-center;
    .actions {
      @apply hidden;
    }
    &:hover {
      .actions {
        @apply flex;
      }
    }
  }
  .list {
    .certificate {
      @apply pt-4-em leading-[inherit] relative;
      .itemActions {
        @apply hidden;
      }
      &:hover {
        .itemActions {
          @apply flex;
        }
      }

      .details {
        @apply flex flex-row justify-between items-start flex-nowrap space-x-2-em;
        .url {
          @apply text-inherit cursor-text;
        }
        .title {
          @apply font-semibold leading-normal;
        }
        .date {
          @apply text-sm-em whitespace-nowrap;
        }
      }
      .issuer {
        @apply leading-normal text-sm-em italic mb-2-em flex flex-row justify-between items-center flex-wrap;
      }
    }
  }
}
</style>
